
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_otpm6_153",
  "marker": "awsui_marker_10ipo_otpm6_205",
  "marker--line": "awsui_marker--line_10ipo_otpm6_245",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_otpm6_249",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_otpm6_256",
  "marker--dashed": "awsui_marker--dashed_10ipo_otpm6_272",
  "root": "awsui_root_10ipo_otpm6_291",
  "value": "awsui_value_10ipo_otpm6_323",
  "expandable": "awsui_expandable_10ipo_otpm6_327",
  "list-item": "awsui_list-item_10ipo_otpm6_331",
  "inner-list-item": "awsui_inner-list-item_10ipo_otpm6_332",
  "key-value-pair": "awsui_key-value-pair_10ipo_otpm6_337",
  "expandable-section": "awsui_expandable-section_10ipo_otpm6_338",
  "key": "awsui_key_10ipo_otpm6_337",
  "sub-items": "awsui_sub-items_10ipo_otpm6_351",
  "list": "awsui_list_10ipo_otpm6_331",
  "compact": "awsui_compact_10ipo_otpm6_377",
  "with-sub-items": "awsui_with-sub-items_10ipo_otpm6_382",
  "full-width": "awsui_full-width_10ipo_otpm6_387"
};
  